import { Alert, Cell, Grid } from 'bold-ui'
import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { Breadcrumb } from 'components/breadcrumb'
import { PageContent } from 'components/layout/PageContent'
import { PageLoading } from 'components/loading'
import { TitleGroup } from 'components/TitleGroup'
import { css } from 'emotion'
import { useAtividadeColetivaGruposVisualizarQuery } from 'graphql/hooks.generated'
import React, { Fragment } from 'react'
import { useLocation, useParams } from 'react-router'
import { Redirect } from 'react-router-dom'

import { AtividadeColetivaGruposForm } from './AtividadeColetivaGruposForm'
import { convertAtividadeColetivaGruposToFormModel } from './converter-atividadeColetivaGrupos'
import { useAtividadeColetivaGruposCache } from './hooks/useAtividadeColetivaGruposCache'

interface AtividadeColetivaGruposEditarViewProps {
  atividadeColetivaGrupoId: ID
}

export const AtividadeColetivaGruposEditarView = () => {
  const { acesso } = useAcessoLotacaoOrEstagio()
  const { cachedValue, setCachedValue, clearCachedValue } = useAtividadeColetivaGruposCache()
  const { atividadeColetivaGrupoId } = useParams<AtividadeColetivaGruposEditarViewProps>()
  const location = useLocation<{ fromView?: boolean }>()
  const fromView = location.state?.fromView ?? false

  const {
    data: { grupoParticipanteAtividadeColetiva },
    loading,
  } = useAtividadeColetivaGruposVisualizarQuery({
    variables: { atividadeColetivaGrupoId },
  })

  if (loading) {
    return <PageLoading message='Carregando...' />
  } else if (!grupoParticipanteAtividadeColetiva) {
    return <Redirect to='/404' />
  }

  return (
    <Fragment>
      <Breadcrumb title='Editar grupo de atividade coletiva' />
      <PageContent type='filled' style={styles.pageContent}>
        <TitleGroup title='Editar grupo de atividade coletiva' style={styles.header} />
        <Grid gap={2}>
          <Cell size={10}>
            <Alert type='warning' inline styles={{ container: styles.alert }}>
              As alterações realizadas não afetam registros anteriores de atividades vinculadas ao grupo.
            </Alert>
          </Cell>
        </Grid>
        <AtividadeColetivaGruposForm
          unidadeSaude={acesso.unidadeSaude}
          initialValues={convertAtividadeColetivaGruposToFormModel(grupoParticipanteAtividadeColetiva)}
          initialDirtyFields={cachedValue}
          setCachedValue={setCachedValue}
          clearCachedValue={clearCachedValue}
          fromView={fromView}
        />
      </PageContent>
    </Fragment>
  )
}

const styles = {
  header: css`
    margin-top: 1rem;
    margin-bottom: 2rem;
  `,
  pageContent: css`
    padding-bottom: 3.5rem;
  `,
  alert: css`
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
  `,
}
